import React, { useContext, useEffect, useState } from 'react';
import { Context } from './global-data-provider';
import api from '../api/api';

export const PostsListContext = React.createContext([]);
export const PostsLoadedContext = React.createContext(false);
export const PostsLoaderContext = React.createContext(null);
export const SetGCategoryContext = React.createContext(null);
export const GCategoryDataContext = React.createContext(null);

function CategoryPostsListProvider(props) {
  const { gCategories, deletedPostManager } = useContext(Context);
  const [postLoaded, setPostLoaded] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [posts, setPosts] = useState([]);
  const [category, setCategory] = useState(null);
  const [categoryLoaded, setCategoryLoaded] = useState('loading');
  const [data, setData] = useState({
    category: undefined,
    uniqTitle: undefined,
    pageNumber: undefined,
  });
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    if (data.category !== undefined && data.pageNumber !== undefined) {
      loadPosts(data.category, data.pageNumber);
    }

    // find and set category.
    if (data.category !== undefined) {
      let found = false;
      Object.keys(gCategories).map((key) => {
        if (parseInt(gCategories[key].id) === parseInt(data.category) && gCategories[key].uniq_title === data.uniqTitle) {
          setCategory(gCategories[key]);
          if (categoryLoaded !== 'ok') {
            setCategoryLoaded('ok');
          }
          found = true;
        }
      });
      if (found === false) {
        setCategoryLoaded('error');
      }
    }
  }, [data]);

  function loadPosts(cat, pn) {
    if (pn === 0 || hasMore) {
      api.getGPosts(cat, pn, deletedPostManager.getListCount()).then((response) => {
        if (response.posts) {
          setPosts(createPostsList(response.posts));

          if (!postLoaded) {
            setPostLoaded(true);
          }

          setHasMore(response.has_more);

          setPageNumber(pn);
        } else {
          setHasMore(false);
        }
      });
    }
  }

  function createPostsList(list) {
    let postList = [];
    for (let i = 0; i < list.length / 3; i++) {
      postList[i] = [];
      for (let j = 0; j < 3; j++) {
        const index = i * 3 + j;
        if (list[index] !== undefined) {
          postList[i][j] = list[index];
        } else {
          break;
        }
      }
    }

    return posts.concat(postList);
  }

  function handleSetCategory(category, uniqTitle) {
    if (category !== data.category) {
      deletedPostManager.reset('gCategory');
      setPostLoaded(false);
      setPosts([]);
      setData({
        category: category,
        uniqTitle: uniqTitle,
        pageNumber: 0,
      });
      setPageNumber(0);
    }
  }

  return (
    <PostsListContext.Provider value={[posts, hasMore, data.pageNumber]}>
      <PostsLoaderContext.Provider value={[loadPosts, pageNumber]}>
        <SetGCategoryContext.Provider value={[handleSetCategory]}>
          <GCategoryDataContext.Provider value={[category, categoryLoaded]}>
            <PostsLoadedContext.Provider value={[postLoaded]}>{props.children}</PostsLoadedContext.Provider>
          </GCategoryDataContext.Provider>
        </SetGCategoryContext.Provider>
      </PostsLoaderContext.Provider>
    </PostsListContext.Provider>
  );
}

export default CategoryPostsListProvider;
